module.exports = __webpack_public_path__ + "static/media/img32.842f5ce0.JPG";